import * as React from 'react';

interface ISvgStarProps {
    isFavorite: boolean;
}

const starSvg: React.StatelessComponent<ISvgStarProps> = props => {
    return (
        <svg className="svg-icon">
            {
                props.isFavorite ? <use xlinkHref="#icon-star-filled" /> : <use xlinkHref="#icon-star-open" />
            }
        </svg>
    );
}

export default starSvg


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/views/star-svg.tsx